
























import Vue, { VueConstructor } from "vue";
import ChordProgressionBuilder from "@/components/ChordProgressionBuilder.vue";
import KeySelector from '@/components/KeySelector.vue'
import ChordSelector from '@/components/ChordSelector.vue'
import PrintableChordProgression from '@/components/PrintableChordProgression.vue'
import hasChordProgression, { HasChordProgressionMixinData } from '@/mixins/hasChordProgression'

export default (Vue as VueConstructor<HasChordProgressionMixinData>).extend({
  name: "Home",
  mixins: [hasChordProgression],
  components: {
    ChordProgressionBuilder,
    KeySelector,
    ChordSelector,
    PrintableChordProgression
  }
})
